<script lang="ts" module>
    import "simplebar"
    import "simplebar/dist/simplebar.min.css"
</script>

<script lang="ts">
    import SliderWrapper from "../SliderWrapper.svelte"
    import Topic from "./Topic.svelte"
    import { lang, topics } from "../../../../store"
    import { kirbyFetch } from "../../../../api/kirby/api"
    import { animateOnVisible } from "../../../../configs/config"
    import { onMount } from "svelte"

    let { block }: { block: TopicSliderBlock } = $props()
    let loading = $state(true)
    let localizedLinks = $state(block?.content?.links || [])
    let el = $state(null)

    type TopicSliderPage = {
        uuid: string
        url: string
    }

    async function loadLocalizedLinks(currentLang: string) {
        if (!block?.content?.links?.length) {
            localizedLinks = []
            loading = false
            return
        }

        const pages =
            (await kirbyFetch<TopicSliderPage[]>({
                query: `site.index.filterBy('Uuid', 'in', ['${block.content.links.map((link) => link.page).join("','")}'])`,
                select: {
                    uuid: true,
                    url: true,
                },
            })) || []

        localizedLinks = block.content.links
            .map((link) => {
                const pageId = Array.isArray(link.page) ? link.page[0] : link.page
                const pageUrl = pages.find((page) => page.uuid === pageId)?.url
                if (!pageUrl) return null
                return {
                    ...link,
                    page: `/${currentLang}/` + pageUrl.split(`/${currentLang}/`).pop(),
                }
            })
            .filter(Boolean)

        loading = false
    }

    onMount(() => {
        animateOnVisible(el, {
            translateX: ["100%", "0rem"],
            opacity: [0, 1],
            duration: 500,
            easing: "easeIn",
        })
    })

    $effect(() => {
        const currentLang = String($lang || "")
        if (!currentLang) return
        void loadLocalizedLinks(currentLang)
    })

    if (typeof window === "undefined") {
        const currentLang = String($lang || "")
        if (currentLang) {
            void loadLocalizedLinks(currentLang)
        }
    }
</script>

<SliderWrapper>
    {#snippet slider()}
        <ul class="inner-wrapper" bind:this={el}>
            {#each Object.values($topics) as topic}
                {#if !loading}
                    <Topic {topic} links={localizedLinks} />
                {/if}
            {/each}
        </ul>
    {/snippet}
</SliderWrapper>

<style lang="less">
    @import "../../../../css/variables.less";
    .inner-wrapper {
        gap: 1px;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(528px, 1fr));
        @media (max-width: 3200px) {
            grid-template-columns: repeat(auto-fill, minmax(459px, 1fr));
        }
        @media (max-width: 2800px) {
            grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
        }
        @media (max-width: 2400px) {
            grid-template-columns: repeat(auto-fill, minmax(358px, 1fr));
        }
        @media (max-width: 2200px) {
            grid-template-columns: repeat(auto-fill, minmax(315px, 1fr));
        }
        @media (max-width: 1920px) {
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        }
        @media (max-width: 1700px) {
            display: flex;
        }
    }
</style>
